import React from "react";
import Chart from "react-apexcharts";
import Piechart from "./Piechart";
import DonutChart from "./Donut";
import "./chartStyles.css";
import RadialChart from "./RadialBar";
import BarGraph from "./BarGraph";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as WorkforceIcon } from "../../../../../assets/svgs/governances-workforce.svg";
import { ReactComponent as BoardDemography } from "../../../../../assets/svgs/governance-board-demographys.svg";
import { ReactComponent as Nationality } from "../../../../../assets/svgs/governance-nationalitys.svg";
import { ReactComponent as Age } from "../../../../../assets/svgs/governances-age.svg";
import { ReactComponent as Expertise } from "../../../../../assets/svgs/governances-expertise.svg";
import { ReactComponent as GovernanceAbled } from "../../../../../assets/svgs/governances-specially-abled.svg";
import { ReactComponent as RNDIcon } from "../../../../../assets/svgs/governances-rnd.svg";
import { ReactComponent as RNDIcons } from "../../../../../assets/svgs/governances2-rnd.svg";
import { ReactComponent as RNDIconss } from "../../../../../assets/svgs/governancess2-rnd.svg";
import { ReactComponent as PolicyIcon } from "../../../../../assets/svgs/governances-policy.svg";
import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
import CarbonCard from "../common/CarbonCard";
import Card from "./Card";
import { useNavigate } from "react-router-dom";
import { THEME_COLORS } from "../../../../../color";
import TimeFilterBar from "../TimeFilterBar";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import PermissionForm from "../../../../Auth/PermissionForm";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";

const policyData = [
  { label: "Health & Safety", value: "Yes" },
  { label: "Social", value: "Yes" },
  { label: "Environmental", value: "Yes" },
  { label: "POSH", value: "Yes" },
  { label: "HRDD", value: "Yes" },
  { label: "Fair Wage Policy", value: "Yes" },
  { label: "Labour Policy", value: "Yes" },
  { label: "Climate Change Policy", value: "Yes" },
  { label: "Carbon Management Policy", value: "Yes" },
  { label: "Waste Management Policy", value: "Yes" },
  { label: "Green Procurement Policy", value: "No" },
  { label: "Ethical Business Conduct Policy ", value: "Yes" },
  {
    label: "Diversity, Equity, and Inclusion Policy For Company ",
    value: "Yes",
  },
  {
    label: "Diversity, Equity, and Inclusion Policy For Board  ",
    value: "No",
  },
  { label: "Business Ethics Conduct Policy", value: "Yes" },
  { label: "CSR Policy", value: "Yes" },
  { label: "Risk management and compliance policy", value: "Yes" },
  { label: "Board Diversity Policy", value: "Yes" },
  { label: "Anti-corruption Policy", value: "Yes" },
  { label: "Data Protection and Privacy Policy", value: "Yes" },
  { label: "Stakeholder Engagement Policy", value: "Yes" },
  { label: "Workplace Health and Safety Policy", value: "Yes" },
  { label: "Water Conservation and Management Policy", value: "Yes" },
  { label: "Biodiversity and Habitat Policy", value: "Yes" },
  { label: "Complaint redressal policy", value: "No" },
  { label: "Governance", value: "Yes" },
  { label: "Open Communication", value: "Yes" },
  { label: "Supply Chain Policy", value: "Yes" },
  { label: "Theft Policy ", value: "Yes" },
  {
    label: "Diversity, Equity, and Inclusion Policy For Company",
    value: "Yes",
  },
  { label: "Diversity, Equity, and Inclusion Policy For Board", value: "Yes" },
];

const SpeciallyAbledCircle = ({
  title,
  percentage,
  abledCount,
  totalCount,
  label,
  color,
  subLabel,
}) => {
  const chartSeries = [percentage];
  const chartOptions = {
    chart: {
      type: "radialBar",
      sparkline: { enabled: true },
      animations: { enabled: false },
    },
    colors: [color],
    plotOptions: {
      radialBar: {
        hollow: {
          size: "48%",
        },
        track: {
          background: "#eef2f3",
        },
        dataLabels: {
          show: false,
        },
      },
    },
    stroke: {
      lineCap: "round",
    },
  };

  return (
    <div className="flex flex-col items-center flex-1">
      {/* Sub-Title */}
      <h3 className="text-[17px] font-bold text-[#06513D] mb-4">{title}</h3>

      {/* Circular Progress with Custom Center Overlay */}
      <div className="relative w-44 h-44 flex items-center justify-center">
        <Chart
          options={chartOptions}
          series={chartSeries}
          type="radialBar"
          width={200}
          height={200}
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center">
          <span className="text-2xl font-extrabold text-gray-800 leading-none">
            {percentage}%
          </span>
          <span className="text-[10px] text-gray-400 mt-1 font-medium text-center max-w-[80px] leading-tight">
            {subLabel}
          </span>
        </div>
      </div>

      {/* Counts Card */}
      <div className="w-full max-w-[210px] bg-[#F7F9F9] border border-gray-100 rounded-lg p-2.5 flex items-center justify-around mt-5">
        <div className="flex flex-col items-center text-center flex-1">
          <span
            className="text-[17px] font-bold leading-none"
            style={{ color }}
          >
            {abledCount}
          </span>
          <span className="text-[9px] text-gray-400 font-semibold mt-1 leading-tight">
            Specially-abled
            <br />
            {label}
          </span>
        </div>
        <div className="w-px h-8 bg-gray-200" />
        <div className="flex flex-col items-center text-center flex-1">
          <span className="text-[17px] font-bold text-gray-800 leading-none">
            {totalCount}
          </span>
          <span className="text-[9px] text-gray-400 font-semibold mt-1 leading-tight">
            Total
            <br />
            {label}
          </span>
        </div>
      </div>
    </div>
  );
};

const Governance = () => {
  const navigate = useNavigate();
  const [showPermission, setPermission] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [activeDashboard, setActiveDashboard] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true" ? "live" : "dummy";
  });
  const [loading, setLoading] = useState(() => {
    return sessionStorage.getItem("hideDummy") === "true";
  });
  const { user, selectedGroupMember } = useSelector((state) => state.auth);
  const [yearFilter, setYearFilter] = useState(() =>
    user?.reportingYearType === "calendar" ? "2026" : "2026-2027",
  );
  const isPermissionCompleted = user?.isCompleted;

  const selectedMemberId =
    selectedGroupMember === "string"
      ? selectedGroupMember
      : selectedGroupMember?.clientId ||
        selectedGroupMember?._id ||
        selectedGroupMember?.client_id?._id ||
        selectedGroupMember?.client_id;

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (activeDashboard !== "live") {
        setLoading(false);
        setDashboardData(null);
        return;
      }

      try {
        setLoading(true);
        let apiUrl;

        if (selectedMemberId) {
          apiUrl = API_URLS.GET_GROUP_MEMBER_DASHBOARD(
            "governance",
            selectedMemberId,
          );
        } else {
          apiUrl = API_URLS.GET_SDG_DASHBOARD("governance");
        }

        const queryParams = new URLSearchParams();
        if (yearFilter) queryParams.append("year", yearFilter);
        const queryString = queryParams.toString()
          ? `?${queryParams.toString()}`
          : "";
        apiUrl += queryString;

        // console.log("Governance Dashboard API Hit:", apiUrl);
        const res = await getApi({
          apiUrl: apiUrl,
        });
        // console.log("Governance Dashboard Response:", res);
        if (res?.data) {
          const data = res.data.dashboard ? res.data.dashboard : res.data;
          setDashboardData(data);
        }
      } catch (error) {
        console.error("Error fetching Governance dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboardData();
  }, [selectedMemberId, activeDashboard, yearFilter]);

  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  const getComponent = (id) =>
    activeDashboard === "live"
      ? dashboardData?.components?.find((c) => c.componentId === id)
      : null;

  const rdVal = getComponent("gov_rd_investment")?.data?.value;
  const rdDisplay =
    activeDashboard === "live"
      ? rdVal !== undefined
        ? `₹ ${(rdVal / 10000000).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} Cr.`
        : "₹ 0 Cr."
      : "₹ 7.23 Cr.";

  const rdRevenuePct = getComponent("gov_rd_revenue_pct")?.data?.percentage;
  const rdRevenuePctDisplay =
    activeDashboard === "live"
      ? rdRevenuePct !== undefined
        ? `Invested ${rdRevenuePct}% of the total revenue in R&D`
        : "Invested 0% of the total revenue in R&D"
      : "Invested 2% of the total revenue in R&D";

  const taxVal = getComponent("gov_total_tax_paid")?.data?.value;
  const taxDisplay =
    activeDashboard === "live"
      ? taxVal !== undefined
        ? `₹ ${(taxVal / 10000000).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} Cr.`
        : "₹ 0 Cr."
      : "₹ 54.24 Cr.";

  const boardComp = getComponent("gov_board_demography");

  const genderLabelMap = {
    male: "Male",
    female: "Female",
    other_gender: "Other",
  };

  const genderData =
    activeDashboard === "live"
      ? boardComp?.data?.gender && boardComp.data.gender.length > 0
        ? boardComp.data.gender.map((g) => ({
            name: genderLabelMap[g.value] || g.value || "Other",
            value: g.percentage || 0,
          }))
        : [
            { name: "Male", value: 0 },
            { name: "Female", value: 0 },
          ]
      : [
          { name: "Male", value: 450 },
          { name: "Female", value: 140 },
          { name: "Other", value: 8 },
        ];
  const totalBoardCount =
    activeDashboard === "live"
      ? boardComp?.data?.totalDirectors > 0
        ? 100
        : 0
      : 0;
  const nationalityLabelMap = {
    indian: "Indian",
    "non-indian": "Non-Indian",
  };

  const nationalityData =
    activeDashboard === "live"
      ? boardComp?.data?.nationality && boardComp.data.nationality.length > 0
        ? boardComp.data.nationality.map((n) => ({
            name:
              nationalityLabelMap[n.value?.toLowerCase()] || n.value || "Other",
            value: n.percentage || 0,
          }))
        : [
            { name: "Indian", value: 0 },
            { name: "Non-Indian", value: 0 },
          ]
      : [
          { name: "Indian", value: 550 },
          { name: "Non-Indian", value: 115 },
        ];

  const ageLabelMap = {
    "21_30": "21-30",
    "31_40": "31-40",
    "41_50": "41-50",
    "51_60": "51-60",
    "61_70": "61-70",
  };

  const ageOrder = ["21_30", "31_40", "41_50", "51_60", "61_70"];
  const expertiseOrder = [
    "0_5",
    "6_10",
    "11_15",
    "16_20",
    "21_25",
    "26_30",
    "30+",
  ];

  const getSortKey = (val, orderList) => {
    const idx = orderList.indexOf(val);
    if (idx !== -1) return idx;
    const num = parseInt(val?.toString().split("_")[0]);
    return isNaN(num) ? 999 : num;
  };

  const ageData =
    activeDashboard === "live"
      ? boardComp?.data?.age && boardComp.data.age.length > 0
        ? [...boardComp.data.age]
            .sort(
              (a, b) =>
                getSortKey(a.value, ageOrder) - getSortKey(b.value, ageOrder),
            )
            .map((a) => ({
              name: ageLabelMap[a.value] || a.value || "Other",
              value: a.percentage || 0,
            }))
        : [
            { name: "21-30", value: 0 },
            { name: "31-40", value: 0 },
            { name: "41-50", value: 0 },
            { name: "51-60", value: 0 },
            { name: "61-70", value: 0 },
          ]
      : [
          { name: "21-30", value: 120 },
          { name: "31-40", value: 200 },
          { name: "41-50", value: 150 },
          { name: "51-60", value: 90 },
          { name: "61-70", value: 38 },
        ];

  const expertiseLabelMap = {
    "0_5": "0-5",
    "6_10": "6-10",
    "11_15": "11-15",
    "16_20": "16-20",
    "21_25": "21-25",
    "26_30": "26-30",
    "30+": "30+",
  };

  const expertiseData =
    activeDashboard === "live"
      ? boardComp?.data?.expertise && boardComp.data.expertise.length > 0
        ? [...boardComp.data.expertise]
            .sort(
              (a, b) =>
                getSortKey(a.value, expertiseOrder) -
                getSortKey(b.value, expertiseOrder),
            )
            .map((e) => ({
              name: expertiseLabelMap[e.value] || e.value || "Other",
              value: e.percentage || 0,
            }))
        : [
            { name: "0-5", value: 0 },
            { name: "6-10", value: 0 },
            { name: "11-15", value: 0 },
            { name: "16-20", value: 0 },
            { name: "21-25", value: 0 },
            { name: "26-30", value: 0 },
            { name: "30+", value: 0 },
          ]
      : [
          { name: "0-5", value: 80 },
          { name: "6-10", value: 120 },
          { name: "11-15", value: 100 },
          { name: "16-20", value: 80 },
          { name: "21-25", value: 60 },
          { name: "26-30", value: 40 },
          { name: "30+", value: 18 },
        ];

  const saComp = getComponent("gov_specially_abled");

  let employeesAbled = 0;
  let employeesTotal = 0;
  let employeesPct = 0;

  let workersAbled = 0;
  let workersTotal = 0;
  let workersPct = 0;

  if (activeDashboard === "live" && saComp?.data) {
    // Correct swapped employees data if abledCount > totalCount
    const empAbledRaw = saComp.data.employees?.abledCount || 0;
    const empTotalRaw = saComp.data.employees?.totalCount || 0;
    if (empAbledRaw > empTotalRaw && empTotalRaw > 0) {
      employeesAbled = empTotalRaw;
      employeesTotal = empAbledRaw;
    } else {
      employeesAbled = empAbledRaw;
      employeesTotal = empTotalRaw;
    }
    employeesPct =
      employeesTotal > 0 ? (employeesAbled / employeesTotal) * 100 : 0;

    // Correct swapped workers data if abledCount > totalCount
    const wrkAbledRaw = saComp.data.workers?.abledCount || 0;
    const wrkTotalRaw = saComp.data.workers?.totalCount || 0;
    if (wrkAbledRaw > wrkTotalRaw && wrkTotalRaw > 0) {
      workersAbled = wrkTotalRaw;
      workersTotal = wrkAbledRaw;
    } else {
      workersAbled = wrkAbledRaw;
      workersTotal = wrkTotalRaw;
    }
    workersPct = workersTotal > 0 ? (workersAbled / workersTotal) * 100 : 0;
  } else {
    // Dummy values matching mockup
    employeesAbled = 30;
    employeesTotal = 100;
    employeesPct = 30;

    workersAbled = 75;
    workersTotal = 100;
    workersPct = 75;
  }

  const speciallyAbledData =
    activeDashboard === "live"
      ? saComp?.data
        ? [
            {
              name: `Specially-abled worker: ${workersAbled} / ${workersTotal}`,
              value: Math.round(workersPct),
            },
            {
              name: `Specially-abled employee: ${employeesAbled} / ${employeesTotal}`,
              value: Math.round(employeesPct),
            },
          ]
        : [
            { name: "Specially-abled worker: 0 / 0", value: 0 },
            { name: "Specially-abled employee: 0 / 0", value: 0 },
          ]
      : [
          { name: "Specially-abled worker: 10 / 45", value: 22 },
          { name: "Specially-abled employee: 5 / 250", value: 2 },
        ];

  const womenComp = getComponent("gov_women_workforce");
  const womenWorkforceData =
    activeDashboard === "live"
      ? (() => {
          const labels = womenComp?.data?.labels || [];
          const values = womenComp?.data?.values || [];
          const getValFlexible = (keys) => {
            for (const key of keys) {
              const idx = labels.findIndex(
                (l) => l && l.toLowerCase().trim() === key.toLowerCase().trim(),
              );
              if (idx !== -1) return values[idx] || 0;
            }
            return 0;
          };

          return [
            {
              name: "Board of Directors",
              value: getValFlexible([
                "Board of Directors",
                "board_of_directors_percentage",
              ]),
            },
            {
              name: "Key Managerial Personnel",
              value: getValFlexible([
                "KMPs",
                "Key Managerial Personnel",
                "kmps_percentage",
              ]),
            },
            {
              name: "Employees",
              value: getValFlexible(["Employees", "employees_percentage"]),
            },
            {
              name: "Workers",
              value: getValFlexible([
                "Workers",
                "Workforce",
                "workforce_percentage",
              ]),
            },
          ];
        })()
      : [
          { name: "Board of Directors", value: 1.02 },
          { name: "Key Managerial Personnel", value: 2.04 },
          { name: "Employees", value: 66.33 },
          { name: "Workers", value: 30.61 },
        ];

  const womenWorkforceMaxVal = Math.max(
    ...(womenWorkforceData || []).map((d) => Number(d.value) || 0),
    0,
  );
  const womenWorkforceYMax =
    womenWorkforceMaxVal > 0
      ? Math.ceil((womenWorkforceMaxVal * 1.2) / 10) * 10
      : 120;

  const sectorComp = getComponent("gov_sector_rd_investment");
  const sectorData =
    activeDashboard === "live"
      ? (() => {
          const labels = sectorComp?.data?.labels || [];
          const values = sectorComp?.data?.values || [];
          return labels.map((label, idx) => ({
            name: label,
            value: values[idx] || 0,
          }));
        })()
      : [
          { name: "Agriculture", value: 2.5 },
          { name: "Steel", value: 1.73 },
          { name: "Cement", value: 3.0 },
        ];

  const policyComp = getComponent("gov_policy_checklist");
  const currentPolicyData =
    activeDashboard === "live"
      ? policyComp?.data
        ? policyComp.data.map((p) => ({
            label: p.label,
            value: p.value ? "Yes" : "No",
          }))
        : []
      : policyData;

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-[#F5F5F5]">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#458276]"></div>
      </div>
    );
  }

  return (
    <div className="p-3 sm:p-4 md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {/* Breadcrumb */}
      {!isPermissionCompleted && showPermission && (
        <PermissionForm permissionConClose={() => setPermission(false)} />
      )}

      <TimeFilterBar
        title=" Governance"
        showBreadcrumb={true}
        breadcrumbItems={["Home", " Governance"]}
        showBackButton={true}
        onBackClick={() => navigate(-1)}
        activeDashboard={activeDashboard}
        onDashboardChange={setActiveDashboard}
        onYearChange={setYearFilter}
        selectedYearValue={yearFilter}
      />
      {/* Top Cards */}
      <div
        className={` ${
          !isPermissionCompleted ? "blur-sm opacity-20 pointer-events-none" : ""
        }`}
      >
        <div className="w-full flex flex-col md:flex-row gap-4 mb-4 mt-2">
          <div className="w-full md:w-1/2">
            <Card
              icon={<RNDIcon className="w-12 h-12 " />}
              title="R&D Investment"
              value={rdDisplay}
              footer={rdRevenuePctDisplay}
              footerBg="#4AC3BD"
            />
          </div>
          <div className="w-full md:w-1/2">
            <Card
              icon={<RNDIcons className="w-12 h-12 " />}
              title="Total Tax Paid"
              value={taxDisplay}
              footer="100% total tax paid as per regulatory commission"
              footerBg="#0087A3"
            />
          </div>
        </div>

        {/* Charts Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 bg-white rounded-lg shadow-md border border-[#3BA2B959] overflow-hidden">
          {/* Board Demography */}
          <div className="p-4 sm:p-5 border-b-2 border-dashed lg:border-r-2 lg:border-b-2">
            <DonutChart
              icon={<BoardDemography className="w-13 h-13 " />}
              title="Board Demography"
              para="Gender"
              width={420}
              height={420}
              totalValue={totalBoardCount}
              options={{
                dataLabels: {
                  enabled: false,
                },
                legend: {
                  show: true,
                  position: "right",
                  width: 130,
                  offsetX: -10,
                  offsetY: 0,
                  itemMargin: {
                    horizontal: 10,
                    vertical: 8,
                  },
                  fontSize: "12px",
                  fontWeight: 700,
                  markers: {
                    size: 10,
                    shape: "square",
                    strokeWidth: 0,
                  },
                },
                responsive: [
                  {
                    breakpoint: 1024,
                    options: {
                      chart: { width: 350, height: 350 },
                      legend: {
                        position: "bottom",
                        offsetY: 10,
                      },
                    },
                  },
                  {
                    breakpoint: 768,
                    options: {
                      chart: { width: 280, height: 280 },
                      legend: {
                        position: "bottom",
                        offsetY: 5,
                        fontSize: "10px",
                      },
                    },
                  },
                ],
              }}
              data={genderData}
            />
          </div>

          {/* Nationality */}
          <div className="p-4 sm:p-5 border-b-2 border-dashed">
            <Piechart
              icon={<Nationality className="w-13 h-13 " />}
              title="Nationality"
              width={420}
              height={420}
              options={{
                dataLabels: {
                  enabled: true,
                  formatter: function (val, { seriesIndex, w }) {
                    return w.config.labels[seriesIndex];
                  },
                  style: {
                    fontSize: "11px",
                    fontWeight: 500,
                    colors: ["#fff"],
                  },
                  dropShadow: {
                    enabled: false,
                  },
                },
                legend: {
                  fontSize: "12px",
                  offsetX: -10,
                  offsetY: 0,
                  width: 130,
                  itemMargin: {
                    horizontal: 10,
                    vertical: 8,
                  },
                  fontWeight: 700,
                  markers: {
                    size: 10,
                    shape: "square",
                    strokeWidth: 0,
                  },
                },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -30,
                      minAngleToShowLabel: 10,
                    },
                  },
                },
                responsive: [
                  {
                    breakpoint: 1024,
                    options: {
                      chart: { width: 350, height: 350 },
                      legend: {
                        position: "bottom",
                        offsetY: 10,
                      },
                    },
                  },
                  {
                    breakpoint: 768,
                    options: {
                      chart: { width: 280, height: 280 },
                      legend: {
                        position: "bottom",
                        offsetY: 5,
                        fontSize: "10px",
                      },
                    },
                  },
                ],
              }}
              data={nationalityData}
            />
          </div>

          {/* Age */}
          <div className="p-4 sm:p-5 border-b-2 border-dashed lg:border-b-0 lg:border-r-2">
            <DonutChart
              icon={<Age className="w-13 h-13 " />}
              title="Age"
              width={380}
              height={380}
              totalValue={totalBoardCount}
              colors={[
                THEME_COLORS.green,
                THEME_COLORS.yellow,
                THEME_COLORS.darkblue,
                THEME_COLORS.pink,
                THEME_COLORS.lightblue,
              ]}
              options={{
                dataLabels: {
                  enabled: false,
                },
                legend: {
                  show: true,
                  position: "right",
                  offsetY: 0,
                  fontSize: "12px",
                  markers: {
                    size: 10,
                    shape: "square",
                    strokeWidth: 0,
                  },
                },
                responsive: [
                  {
                    breakpoint: 1024,
                    options: {
                      chart: { width: 350, height: 350 },
                      legend: {
                        position: "bottom",
                        offsetY: 10,
                      },
                    },
                  },
                  {
                    breakpoint: 768,
                    options: {
                      chart: { width: 280, height: 280 },
                      legend: {
                        position: "bottom",
                        offsetY: 5,
                        fontSize: "10px",
                      },
                    },
                  },
                ],
              }}
              data={ageData}
            />
          </div>

          {/* Expertise */}
          <div className="p-4 sm:p-5">
            <DonutChart
              icon={<Expertise className="w-13 h-13 " />}
              title="Expertise"
              width={380}
              height={380}
              totalValue={totalBoardCount}
              colors={[
                THEME_COLORS.green,
                THEME_COLORS.yellow,
                THEME_COLORS.darkblue,
                THEME_COLORS.pink,
                THEME_COLORS.lightblue,
              ]}
              options={{
                dataLabels: {
                  enabled: false,
                },
                legend: {
                  show: true,
                  position: "right",
                  offsetY: 0,
                  fontSize: "12px",
                  markers: {
                    size: 10,
                    shape: "square",
                    strokeWidth: 0,
                  },
                },
                responsive: [
                  {
                    breakpoint: 1024,
                    options: {
                      chart: { width: 350, height: 350 },
                      legend: {
                        position: "bottom",
                        offsetY: 10,
                      },
                    },
                  },
                  {
                    breakpoint: 768,
                    options: {
                      chart: { width: 280, height: 280 },
                      legend: {
                        position: "bottom",
                        offsetY: 5,
                        fontSize: "10px",
                      },
                    },
                  },
                ],
              }}
              data={expertiseData}
            />
          </div>
        </div>
        {/* Bottom Charts Row */}
        <div className="flex flex-col lg:flex-row gap-4 mt-4 w-full">
          {/* Women Workforce */}
          <div className="w-full lg:w-1/2 bg-white p-4 rounded-lg shadow-md border-2 border-[#3DA3BA59]">
            <BarGraph
              icon={<WorkforceIcon className="w-12 h-12 " />}
              title="Women Workforce"
              width="100%"
              height={450} // adjust height if needed
              data={womenWorkforceData}
              options={{
                dataLabels: {
                  enabled: true,
                  offsetY: -20,
                  style: {
                    fontSize: "12px",
                    fontWeight: "normal",
                    colors: ["#000"],
                  },
                  formatter: (val) => `${val}%`,
                },
                grid: {
                  padding: {
                    bottom: 80,
                  },
                },

                xaxis: {
                  title: {
                    text: "Women Workforce",
                    offsetY: 30,
                    style: {
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#000",
                    },
                  },
                  axisBorder: {
                    show: true,
                    color: "#000",
                  },
                  axisTicks: {
                    show: false,
                  },
                  labels: {
                    rotate: -45,
                    rotateAlways: false,
                    hideOverlappingLabels: false,
                    trim: false,
                    minHeight: 50,
                    style: {
                      fontSize: "11px",
                      fontWeight: "normal",
                      colors: ["#000", "#000", "#000", "#000"],
                    },
                  },
                },
                yaxis: {
                  min: 0,
                  max: womenWorkforceYMax,
                  tickAmount: 12,
                  title: {
                    text: "Percentage (%)",
                    style: {
                      fontSize: "12px",
                      fontWeight: "normal",
                      color: "#000",
                    },
                  },
                  labels: {
                    formatter: (val) => `${val}%`,
                    style: {
                      fontSize: "11px",
                      fontWeight: "normal",
                      colors: ["#000"],
                    },
                  },
                  axisBorder: {
                    show: true,
                    color: "#000",
                    width: 2,
                  },
                  axisTicks: {
                    show: true,
                    color: "#000",
                  },
                },
                responsive: [
                  {
                    breakpoint: 480,
                    options: {
                      chart: { width: "100%", height: 280 },
                      legend: {
                        position: "bottom",
                        horizontalAlign: "center",
                        fontSize: "9px",
                      },
                      dataLabels: {
                        style: { fontSize: "9px" },
                        offsetY: -14,
                      },
                      xaxis: {
                        labels: {
                          rotate: -45,
                          rotateAlways: true,
                          style: { fontSize: "9px" },
                          trim: false,
                          minHeight: 55,
                        },
                      },
                      grid: { padding: { bottom: 45 } },
                    },
                  },
                  {
                    breakpoint: 768,
                    options: {
                      chart: { width: "100%", height: 310 },
                      legend: {
                        position: "bottom",
                        horizontalAlign: "center",
                        fontSize: "10px",
                      },
                      dataLabels: {
                        style: { fontSize: "10px" },
                        offsetY: -16,
                      },
                      xaxis: {
                        labels: {
                          rotate: -35,
                          rotateAlways: true,
                          style: { fontSize: "10px" },
                          trim: false,
                          minHeight: 50,
                        },
                      },
                      grid: { padding: { bottom: 40 } },
                    },
                  },
                  {
                    breakpoint: 1024,
                    options: {
                      chart: {
                        width: "100%",
                      },
                      dataLabels: {
                        style: {
                          fontSize: "10px",
                        },
                      },
                      xaxis: {
                        labels: {
                          style: {
                            fontSize: "10px",
                          },
                        },
                      },
                    },
                  },
                ],
              }}
            />
          </div>

          {/* Specially-abled Workforce */}
          <div className="w-full lg:w-1/2 bg-white p-5 rounded-lg shadow-md border-2 border-[#3DA3BA59] flex flex-col">
            {/* Header */}
            <div className="flex items-start gap-3 mb-4">
              <GovernanceAbled className="w-12 h-12 flex-shrink-0" />
              <div style={{ color: THEME_COLORS.green }}>
                <h2 className="font-calibri font-bold text-base md:text-lg m-0 leading-tight">
                  Specially-Abled Workforce
                </h2>
                <p className="text-xs text-gray-500 font-normal m-0 mt-1 leading-tight">
                  Percentage of specially-abled employees and workers
                </p>
              </div>
            </div>

            {/* Custom Circular Indicators Side-by-Side */}
            <div className="flex-grow flex flex-row items-center justify-around gap-4 pt-2">
              <SpeciallyAbledCircle
                title="Employees"
                percentage={Math.round(employeesPct)}
                abledCount={employeesAbled}
                totalCount={employeesTotal}
                label="Employees"
                color={THEME_COLORS.yellow}
                subLabel="of total employees"
              />
              <div className="w-px h-48 bg-gray-200 self-center hidden sm:block" />
              <SpeciallyAbledCircle
                title="Workers"
                percentage={Math.round(workersPct)}
                abledCount={workersAbled}
                totalCount={workersTotal}
                label="Workers"
                color={THEME_COLORS.green}
                subLabel="of total workers"
              />
            </div>
          </div>
        </div>

        {/* R&D Investment Chart */}
        <div className="mt-4 bg-white p-3 sm:p-4 rounded-lg shadow-md border-2 border-[#3DA3BA59]">
          <BarGraph
            title="Sector Specific R&D Investment"
            width="100%"
            options={{
              dataLabels: {
                enabled: true,
                offsetY: -20,
                formatter: (val) => val.toLocaleString(),
                style: {
                  fontSize: "11px",
                  fontWeight: "bold",
                  colors: ["#304758"],
                },
              },
              xaxis: {
                title: {
                  text: "Sector",
                  style: {
                    fontSize: "12px",
                    fontWeight: "normal",
                    color: "#000",
                  },
                },
              },

              yaxis: {
                title: {
                  text: "Investment (in INR )",
                  style: {
                    fontSize: "12px",
                    fontWeight: "normal",
                    color: "#000",
                  },
                },
                labels: {
                  formatter: (val) => `${val}`,
                  style: {
                    fontSize: "11px",
                    fontWeight: "normal",
                    colors: ["#000"],
                  },
                },
                axisBorder: {
                  show: true,
                  color: "#010708",
                },
                axisTicks: {
                  show: false,
                },
              },

              tooltip: {
                enabled: true,
                y: {
                  formatter: (val) => `${val}`,
                },
              },
            }}
            data={sectorData}
          />
        </div>

        {/* Policy Section */}
        <div className="mt-4 bg-white p-3 sm:p-4 rounded-lg shadow-md border-2 border-[#3DA3BA59] mb-10">
          <div className="flex gap-x-4 items-center mb-4">
            <div className=" p-1 ">
              <PolicyIcon className="w-12 h-12 " />
            </div>
            <h2
              className="text-[1rem] sm:text-[1.15rem] m-0 p-0 font-calibri font-bold leading-6 tracking-[0%]"
              style={{ color: THEME_COLORS.green }}
            >
              Policy
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-3 sm:gap-x-4 sm:gap-y-4">
            {currentPolicyData.map(({ label, value }, index) => (
              <div
                key={index}
                className="flex justify-between items-center px-3 py-2 sm:px-4 border-2 rounded-md border-[#3DA3BA38]"
              >
                <span className="text-xs sm:text-sm lg:text-base pr-2">
                  {label}
                </span>
                <span className="text-xs sm:text-sm lg:text-base font-medium">
                  {value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Governance;
